var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 0.5H2.50016C1.57516 0.5 0.833496 1.24167 0.833496 2.16667V12.1667C0.833496 13.0833 1.57516 13.8333 2.50016 13.8333H6.66683V15.5H13.3335V13.8333H17.5002C18.4168 13.8333 19.1585 13.0833 19.1585 12.1667L19.1668 2.16667C19.1668 1.24167 18.4168 0.5 17.5002 0.5ZM17.5002 12.1667H2.50016V2.16667H17.5002V12.1667ZM13.3335 7.16667L7.50016 10.5V3.83333L13.3335 7.16667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/playBtn.6551d554c3a02b27e99fcd3a3c653d21.svg";
export { ForwardRef as ReactComponent };